import { useLocation } from 'react-router-dom';
import { isArchiveSearch, withArchive } from 'src/resources/withArchive';

/** Archive mode is driven by the `archive=1` query parameter of the current page URL. */
export const isArchiveMode = (): boolean => isArchiveSearch(window.location.search);

/** Appends `archive=1` to the url when the current page is opened in archive mode. */
export const withArchiveMode = (url: string): string => withArchive(url, isArchiveMode());

export const useArchiveMode = (): boolean => isArchiveSearch(useLocation().search);
